// extracted by mini-css-extract-plugin
export default {"container":"Grid_container__l3Mfi","box":"Grid_box__WOLtl","won":"Grid_won__CqfEh","content":"Grid_content__I7Asj","button":"Grid_button__o2sDk"};